import type { OfficeSearchParams } from "./types/office-search-params";

function buildOfficeSearchUrl(
  baseUrl: string,
  path: "search" | "hiring",
  params: OfficeSearchParams,
): string {
  const searchParams = new URLSearchParams({
    geoSearchTerm: params.geoSearchTerm,
  });

  if (params.forceProximitySearch !== undefined) {
    searchParams.set(
      "forceProximitySearch",
      String(params.forceProximitySearch),
    );
  }

  if (params.mileRadius !== undefined) {
    searchParams.set("mileRadius", String(params.mileRadius));
  }

  return `${baseUrl}/api/v1/offices/${path}?${searchParams.toString()}`;
}

export { buildOfficeSearchUrl };
